import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "list",
    "noResults",
    "newItem",
    "hiddenInput",
    "hiddenName",
  ];

  static values = {
    formType: String,
  };

  connect() {
    this.items = Array.from(
      this.listTarget.querySelectorAll(
        'li:not([data-autocomplete-target="noResults"])'
      )
    ).map((li) => ({ id: li.dataset.id, name: li.textContent.trim() }));
  }

  search() {
    const text = this.inputTarget.value.trim();
    const query = text.toLowerCase();
    let hasResult = false;

    this.listTarget.classList.remove("hidden");

    this.items.forEach((item, index) => {
      const li = this.listTarget.children[index];
      if (item.name.toLowerCase().includes(query)) {
        li.classList.remove("hidden");
        hasResult = true;
      } else {
        li.classList.add("hidden");
      }
    });

    if (!query || hasResult) {
      this.noResultsTarget.classList.add("hidden");
    } else {
      this.noResultsTarget.classList.remove("hidden");
      this.newItemTarget.textContent = text;
    }

    // Si l'utilisateur modifie le texte, effacer l'id caché
    this.hiddenInputTarget.value = "";
    this.hiddenNameTarget.value = "";
  }

  select(event) {
    const selection = event.target.textContent.trim();
    const selectedId = event.target.dataset.id;

    this.inputTarget.value = selection;
    this.hiddenInputTarget.value = selectedId || "";

    this.close();
    this.inputTarget.dispatchEvent(new Event("autocomplete:select"));

    if (this.formTypeValue === "autosubmit") {
      const form = this.element.closest("form");

      if (form) {
        form.requestSubmit();
      }
    }
  }

  open() {
    this.listTarget.classList.remove("hidden");
  }

  closeWithDelay() {
    setTimeout(() => this.close(), 150);
  }

  close() {
    this.listTarget.classList.add("hidden");
  }

  fillName() {
    const text = this.inputTarget.value.trim();
    this.hiddenNameTarget.value = text || "";
  }
}
